export const NOBIS = [
  'GUmlznuuR67bnpY1PL2f',
  'dqTXPIxjTPr1Sy76koaE',
  'kY2m4Xf6p2c6GB6kG0Ho',
  'pki0hPY25xE2dawpqOxL',
  'fzTM7EZz6WxQFgunsCIP',
];
export const VISITAR = ['II2AFAIMtmJCIeSSM0i8', 'tAahRjMOqFE1M9bxxlNa'];
export const SOLANO = ['Spw3PazWQRSeK5sLj0WZ'];
export const ARAUCARIA = ['oev7R0ammzclj7j8q5Ih'];
export const BEAUTY = ['joFgyeqz4pldwxOzvIVM'];
export const CARRODILLA = ['tI2EvjVYL6gjrgv1MPvw'];
export const CENTROVISION = ['ypi0hvPqEhketc1KLRnw'];
export const BERNAL = ['pi84qi1LFHMwYo49fGKm'];
export const ASISTIR = ['83ohZvUAWbB5rcAXmr1A', 'GUmlznuuR67bnpY1PL2f', 'iuBcbwwftLXlzw6sWRqH'];
export const ASISTIRAC = ['gVSdUxlh4B58ReTMT8gJ'];
export const SUMA = ['yvFOV3r2X73cffXra4sH', 'O2xD6MIB4mO41iMLbzRi'];
export const SUMAMKT = ['5ZzwXZf7kOMHojmBCI6B'];
export const MAYO = ['LFsyWv9G3xk6qKnUi6t1'];
export const CITO = ['kouquTzhQ31x7J3fhn4Y'];
export const CIMO = ['ofWJi8SuMoMiaK9y8Ivx'];
export const RAS = ['d6eVIrUV1HiLkGvoHOox', 'tI2EvjVYL6gjrgv1MPvw', 'GlWvIRRQjTOXSBMhxtQK'];
export const MT4 = ['tI2EvjVYL6gjrgv1MPvw'];

export const UNUSED = [
  'cWmFbkvzZVkAhmQnp7Xg',
  'ZGFpAE1DJwPbwOK7ZuL9',
  'joFgyeqz4pldwxOzvIVM',
  'lcGKh5eXO0RpwxMwFCi8',
];
